<template>
  <RoomDisplay :kiosk-key="kioskKey" :room-filter="room" />
</template>

<script>
import RoomDisplay from './components/RoomDisplay.vue';

export default {
  name: 'App',
  components: { RoomDisplay },
  setup() {
    const params   = new URLSearchParams(window.location.search);
    const kioskKey = params.get('key') || '';
    const room     = params.get('room') || '';
    return { kioskKey, room };
  },
};
</script>
